import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const WorkflowDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(WorkflowDetailsContent, { blamelog: blamelog })))));
};
const WorkflowDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.WorkflowChangeOnCase:
            return React.createElement(WorkflowChangeOnCaseContent, { blamelog: blamelog });
        case BlameLogType.WorkflowRollback:
            return React.createElement(WorkflowRollbackContent, { blamelog: blamelog });
        case BlameLogType.WorkflowChange:
            return React.createElement(WorkflowChangeContent, { blamelog: blamelog });
        case BlameLogType.DeleteUpdate:
            return React.createElement(DeleteUpdateContent, { blamelog: blamelog });
        case BlameLogType.BulkAction:
            return React.createElement(BulkActionContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const WorkflowChangeOnCaseContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    const workflowsLoadable = useWorkflows();
    const workflows = h.hasData(workflowsLoadable) ? workflowsLoadable.data : [];
    const fromWorkflow = workflows.find((w) => w.workflowId === details.fromWorkflowId);
    const toWorkflow = workflows.find((w) => w.workflowId === details.toWorkflowId);
    return (React.createElement(React.Fragment, null,
        details.fromWorkflowId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromWorkflow)),
            React.createElement("td", null, fromWorkflow?.title || details.fromWorkflowId))),
        details.toWorkflowId && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toWorkflow)),
            React.createElement("td", null, toWorkflow?.title || details.toWorkflowId)))));
};
const WorkflowRollbackContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.workflowTitle && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.workflow)),
            React.createElement("td", null, details.workflowTitle))),
        details.label && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.label)),
            React.createElement("td", null, details.label)))));
};
const WorkflowChangeContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    const workflowsLoadable = useWorkflows();
    const workflows = h.hasData(workflowsLoadable) ? workflowsLoadable.data : [];
    const workflow = workflows.find((w) => w.workflowId === details.workflowId);
    const prevWorkflow = details.prevWorkflowId
        ? workflows.find((w) => w.workflowId === details.prevWorkflowId)
        : null;
    return (React.createElement(React.Fragment, null,
        details.prevWorkflowId && prevWorkflow && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fromWorkflow)),
            React.createElement("td", null, prevWorkflow.title))),
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.toWorkflow)),
            React.createElement("td", null, workflow?.title || details.workflowId))));
};
const DeleteUpdateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.label && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.label)),
            React.createElement("td", null, lang.updateTypes[details.updateTypeId] || details.label))),
        details.description && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.description)),
            React.createElement("td", null, details.description))),
        details.update && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.note)),
            React.createElement("td", null, details.update))),
        details.createdAt && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.createdAt)),
            React.createElement("td", null, moment(details.createdAt).format(THEME.DATE_FORMAT_LONG))))));
};
const BulkActionContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.bulkActions.bulkActions)),
            React.createElement("td", null, details.actionType in lang.bulkActionTypes
                ? lang.bulkActionTypes[details.actionType]
                : details.actionType))));
};
//# sourceMappingURL=WorkflowDetails.js.map